import { format } from "date-fns";
import { Alert, Box, Button, Drawer, IconButton, Link, Paper, Stack, Typography } from "@mui/material";
import Iconify from "../../../minimals/components/iconify";
import { DocumentsOrderInfo } from "../types";

const formatShortDate = (value?: string) => {
  if (!value) {
    return "--";
  }

  return format(new Date(value), "M/d/yyyy");
};

export function NotesDrawer({
  open,
  orderNumber,
  notes,
  onClose
}: {
  open: boolean;
  orderNumber: string;
  notes: DocumentsOrderInfo["notes"];
  onClose: () => void;
}) {
  const visibleNotes = notes ?? [];

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: 460 },
          maxWidth: "100%"
        }
      }}
    >
      <Stack sx={{ height: "100%" }}>
        <Box
          sx={{
            px: 2,
            py: 0.75,
            borderBottom: "1px solid",
            borderColor: "divider"
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h6" sx={{ fontWeight: 900, lineHeight: 1.3 }}>
              Notes
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              <Button
                component="a"
                href={`/notes/${encodeURIComponent(orderNumber)}`}
                target="_blank"
                rel="noopener noreferrer"
                variant="outlined"
                size="small"
                endIcon={<Iconify icon="eva:external-link-fill" />}
                sx={{ borderRadius: 1, fontWeight: 800, textTransform: "none" }}
              >
                All Notes
              </Button>
              <IconButton size="small" onClick={onClose}>
                <Iconify icon="eva:close-fill" />
              </IconButton>
            </Stack>
          </Stack>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.3, mt: 0.5 }}>
            {orderNumber}
          </Typography>
        </Box>

        <Box sx={{ flex: 1, overflow: "auto", p: 1.5 }}>
          {visibleNotes.length === 0 ? (
            <Alert severity="info">No notes found for this order.</Alert>
          ) : (
            <Stack spacing={1}>
              {visibleNotes.map((note, index) => (
                <Paper
                  key={`${note.createdOn}-${index}`}
                  variant="outlined"
                  sx={{
                    p: 1.25,
                    borderRadius: 1,
                    backgroundColor: "#f7f7f9",
                    borderColor: note.displayOnOrderOpen ? "primary.dark" : "divider",
                    color: "primary.dark"
                  }}
                >
                  <Typography sx={{ whiteSpace: "pre-wrap", lineHeight: 1.4, fontSize: 14 }}>{note.text}</Typography>
                  <Typography variant="body2" sx={{ mt: 0.5, fontWeight: 700, fontSize: 12 }}>
                    -{" "}
                    <Box component="span" sx={{ color: "#ee765c" }}>
                      {note.fullName}
                    </Box>{" "}
                    on {formatShortDate(note.createdOn)}
                  </Typography>
                </Paper>
              ))}
            </Stack>
          )}
        </Box>
      </Stack>
    </Drawer>
  );
}


